<template>
    <div>
        <menu-bar />
        <div class="container" role="main" v-if="contrato">
            <div class="row" style="margin-top: 50px">
                <ol class="breadcrumb">
                    <li>
                        <a href="#/"
                            ><i class="fa fa-home" aria-hidden="true"></i>
                            INICIAL</a
                        >
                    </li>
                    <li>
                        <a href="#/contratos"
                            ><i class="fa fa-suitcase" aria-hidden="true"></i>
                            CONTRATOS</a
                        >
                    </li>
                    <li class="active">CADASTRO DE CONTRATOS</li>
                </ol>

                <div class="row">
                    <div class="col-md-3">
                        <contrato-menu :contrato="contrato" />
                    </div>

                    <div class="col-md-9" v-if="contrato">
                        <status-bloqueio :bloqueado="contrato.bloqueado" />
                        <router-view />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import contratoMixin from "../../mixins/contrato";
import { StatusBloqueio, ContratoMenu } from "../../../components/exports";
export default {
    components: {
        ContratoMenu,
        StatusBloqueio
    },
    mixins: [contratoMixin]
};
</script>
